import $ from "jquery";
window.$ = window.jQuery = $;
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

export const homeHeroSlider = () => {
	(($) => {
		$(".section-hero .hero").slick({
			infinite: !0,
			autoplay: !0,
			autoplaySpeed: 5000,
			pauseOnHover: !0,
			fade: !0,
			dots: !0,
			arrows: !1,
			slidesToShow: 1,
			slidesToScroll: 1,
			appendDots: $(".section-hero .slick-dots-container"),
		});

		$(".section-hero .hero").on("touchstart", (e) => {
			$(".section-hero .hero").slick("slickPlay");
		});
	})(jQuery);
};

export const gameSlider = () => {
	(($) => {
		$(".games-slider-for").slick({
			pauseOnFocus: !1,
			pauseOnHover: !1,
			autoplay: !1,
			infinite: !0,
			fade: !0,
			slidesToShow: 1,
			slidesToScroll: 1,
			draggable: !1,
			swipe: !1,
			swipeToSlide: !1,
			touchMove: !1,
			rows: 0,
			prevArrow: '<button class="slick-prev btn-outline" aria-label="Previous"></button>',
			nextArrow: '<button class="slick-next btn-outline" aria-label="Next"></button>',
			appendArrows: $(".section-games .games-slider-for-arrows"),
			asNavFor: ".games-slider-nav",
		});

		const btn_prev = $(".games-slider-nav").attr("data-btn-prev"),
			btn_next = $(".games-slider-nav").attr("data-btn-next"),
			cen_pddg = ($(window).width() - $(".section-games .container").outerWidth()) / 2;

		$(".games-slider-nav").on("init", (event, slick) => {
			const sl_cur = $(".slick-current");
			sl_cur.prev().addClass("slick-left");
			sl_cur.prev().prev().addClass("slick-left-2");
			sl_cur.prev().prev().prev().addClass("slick-left-3");
			sl_cur.prev().prev().prev().prev().addClass("slick-left-3");
			sl_cur.prev().prev().prev().prev().prev().addClass("slick-hide");
			sl_cur.next().addClass("slick-right");
			sl_cur.next().next().addClass("slick-right-2");
			sl_cur.next().next().next().addClass("slick-right-3");
			sl_cur.next().next().next().next().addClass("slick-hide");
		});

		$(".games-slider-nav").slick({
			autoplay: !1,
			infinite: !0,
			pauseOnFocus: !1,
			pauseOnHover: !1,
			centerMode: !0,
			centerPadding: cen_pddg + "px",
			slidesToShow: 3,
			slidesToScroll: 1,
			touchMove: !1,
			rows: 0,
			prevArrow:
				'<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><span>' +
				btn_prev +
				"</span></button>",
			nextArrow:
				'<button class="slick-next slick-arrow" aria-label="Next" type="button"><span>' + btn_next + "</span></button>",
			asNavFor: ".games-slider-for",
			responsive: [
				{
					breakpoint: 992,
					settings: {
						arrows: !1,
						slidesToShow: 1,
						centerPadding: "25%",
					},
				},
			],
		});

		const slickAnim = () => {
			$(".slick-slide").removeClass(
				"slick-hide slick-left slick-left-2 slick-left-3 slick-right slick-right-2 slick-right-3",
			);
			$(".slick-current").prev().addClass("slick-left");
			$(".slick-current").prev().prev().addClass("slick-left-2");
			$(".slick-current").prev().prev().prev().addClass("slick-left-3");
			$(".slick-current").prev().prev().prev().prev().addClass("slick-hide");
			$(".slick-current").next().addClass("slick-right");
			$(".slick-current").next().next().addClass("slick-right-2");
			$(".slick-current").next().next().next().addClass("slick-right-3");
			$(".slick-current").next().next().next().next().addClass("slick-hide");

			if ($(".slick-last").hasClass("slick-current")) {
				$(".slick-last").prev().addClass("slick-left");
				$(".slick-last").prev().prev().addClass("slick-left-2");
				$(".slick-last").next().addClass("slick-right");
				$(".slick-last").next().next().addClass("slick-right-2");
				$(".slick-last").next().next().next().addClass("slick-right-3");
				$(".slick-last").next().next().next().next().addClass("slick-hide");
			}

			if ($(".slick-first").hasClass("slick-current")) {
				$(".slick-first").next().addClass("slick-right");
				$(".slick-first").next().next().addClass("slick-right-2");
				$(".slick-first").prev().addClass("slick-left");
				$(".slick-first").prev().prev().addClass("slick-left-2");
				$(".slick-first").prev().prev().prev().addClass("slick-left-3");
				$(".slick-first").prev().prev().prev().prev().addClass("slick-hide");
			}
		};
		$(".games-slider-nav").on("swipe", slickAnim);

		$(".section-games .slick-arrow").click(() => {
			slickAnim();
		});

		const g_s_prev = $(".games-slider-nav .slick-prev"),
			g_s_next = $(".games-slider-nav .slick-next"),
			g_s_more = $(".games-slider-nav .slick-current");

		g_s_prev.mousemove((mm) => {
			const mX = mm.pageX - g_s_prev.offset().left,
				mY = mm.pageY - g_s_prev.offset().top;

			g_s_prev.find("span").css({
				left: mX,
				top: mY,
			});
		});

		g_s_next.mousemove((mm) => {
			const mX = mm.pageX - g_s_next.offset().left,
				mY = mm.pageY - g_s_next.offset().top;

			g_s_next.find("span").css({
				left: mX,
				top: mY,
			});
		});

		g_s_more.mousemove((mm) => {
			const mX = mm.pageX - g_s_more.offset().left,
				mY = mm.pageY - g_s_more.offset().top;

			g_s_more.find(".games-link").css({
				left: mX,
				top: mY,
			});
		});

		$(".games-slider-nav").on("afterChange", () => {
			const g_s_more = $(".games-slider-nav .slick-current");
			g_s_more.mousemove((mm) => {
				const mX = mm.pageX - g_s_more.offset().left,
					mY = mm.pageY - g_s_more.offset().top;

				g_s_more.find(".games-link").css({
					left: mX,
					top: mY,
				});
			});
		});
	})(jQuery);
};

export const partnerSlider = () => {
	(($) => {
		const cp = ($(window).width() - $(".section-partners .container").width()) / 2;

		$(".section-partners .partners-slider").on("init", (event, slick) => {
			$(".section-partners .slick-current").prev().prev().addClass("slick-hide");
		});

		$(".section-partners .partners-slider").slick({
			infinite: !0,
			autoplay: !1,
			autoplaySpeed: 5000,
			pauseOnHover: !0,
			slidesToShow: 3,
			slidesToScroll: 1,
			centerMode: !0,
			centerPadding: cp + "px",
			prevArrow: '<button class="slick-prev btn-outline" aria-label="Previous"></button>',
			nextArrow: '<button class="slick-next btn-outline" aria-label="Next"></button>',
			appendArrows: $(".section-partners .partners-slider-for-arrows"),
			responsive: [
				{
					breakpoint: 1280,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		});

		const slickHide = () => {
			$(".section-partners .slick-slide").removeClass("slick-hide");
			$(".section-partners .slick-current").prev().prev().addClass("slick-hide");
		};
		$(".section-partners .partners-slider").on("afterChange", slickHide);
	})(jQuery);
};

export const gameSliderSingle = () => {
	if (document.body.classList.contains("single-game")) {
		var thumbs = new Swiper(".gallery-thumbs", {
			spaceBetween: 10,
			slidesPerView: 6,
			freeMode: !0,
		});

		var slider = new Swiper(".gallery-slider", {
			loop: !0,
			autoplay: {
				delay: 5000,
				disableOnInteraction: !1,
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: !0,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			thumbs: {
				swiper: thumbs,
			},
		});

		var ytframe = document.getElementsByTagName("iframe"),
			gSlider = document.getElementsByClassName("gallery-slider")[0];
		document.getElementsByClassName("swiper-button-prev")[0].onclick = () => {
			gSlider.swiper.autoplay.start();

			for (var i = 0; i < ytframe.length; i++) {
				ytframe[i].contentWindow.postMessage('{"event":"command", "func":"' + "pauseVideo" + '", "args":""}', "*");
			}
		};

		document.getElementsByClassName("swiper-button-next")[0].onclick = () => {
			gSlider.swiper.autoplay.start();

			for (var i = 0; i < ytframe.length; i++) {
				ytframe[i].contentWindow.postMessage('{"event":"command", "func":"' + "pauseVideo" + '", "args":""}', "*");
			}
		};

		document.getElementsByClassName("swiper-pagination")[0].onclick = () => {
			gSlider.swiper.autoplay.start();

			for (var i = 0; i < ytframe.length; i++) {
				ytframe[i].contentWindow.postMessage('{"event":"command", "func":"' + "pauseVideo" + '", "args":""}', "*");
			}
		};

		document.getElementsByClassName("gallery-thumbs")[0].onclick = () => {
			gSlider.swiper.autoplay.start();

			for (var i = 0; i < ytframe.length; i++) {
				ytframe[i].contentWindow.postMessage('{"event":"command", "func":"' + "pauseVideo" + '", "args":""}', "*");
			}
		};

		window.setInterval(() => {
			if (document.activeElement instanceof HTMLIFrameElement) {
				gSlider.swiper.autoplay.stop();
			}
		}, 1000);
	}
};

export const careerSlider = () => {
	(($) => {
		$(".section-col-slider .career-slider-nav").slick({
			infinite: !0,
			autoplay: !0,
			autoplaySpeed: 5000,
			pauseOnHover: !0,
			dots: !1,
			fade: !0,
			prevArrow: '<button class="slick-prev btn-outline" aria-label="Previous"></button>',
			nextArrow: '<button class="slick-next btn-outline" aria-label="Next"></button>',
			appendArrows: $(".career-slider-arrows"),
			asNavFor: ".career-slider-for",
		});

		$(".section-col-slider .career-slider-for").slick({
			infinite: !0,
			autoplay: !0,
			autoplaySpeed: 5000,
			pauseOnHover: !0,
			dots: !1,
			arrows: !1,
			rows: 0,
			asNavFor: ".career-slider-nav",
		});
	})(jQuery);
};

export const featuredRoleSlider = () => {
	(($) => {
		const frs = $(".section-featured-roles .featured-roles-slider"),
			frSlide = () => {
				frs.on("init", (event, slick) => {
					frs.addClass("no-gutter");
					$(".section-featured-roles .career-btn").addClass("justify-content-between");
				});

				if ($(window).width() < 896) {
					frs.slick({
						infinite: !0,
						autoplay: !0,
						autoplaySpeed: 5000,
						pauseOnHover: !0,
						dots: !1,
						rows: 0,
						prevArrow: '<button class="slick-prev btn-outline" aria-label="Previous"></button>',
						nextArrow: '<button class="slick-next btn-outline" aria-label="Next"></button>',
						appendArrows: $(".featured-roles-arrows"),
					});
				} else {
					if (frs.hasClass("slick-initialized")) {
						frs.slick("unslick");
					}
				}
			};

		frSlide();
		$(window).resize(() => {
			frSlide();
		});
	})(jQuery);
};
